import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Contacts } from '../../components/Contacts';
import { selectBuilderInfo } from '../../selectors/builder';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { trackShowPhoneClick } from './tracking';
import { CallbackButtonContainer } from '../CallbackButtonContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';

export const ContactsContainer = () => {
  const builderInfo = useSelector(selectBuilderInfo);

  const handleShowPhone = useEventCallback(() => {
    trackShowPhoneClick(builderInfo.id);
  });

  return (
    <Contacts
      {...builderInfo}
      phoneButton={<PhoneButtonContainer size="M" onShow={handleShowPhone} />}
      callbackButton={<CallbackButtonContainer placement={ECallbackWidgetPlacement.Contacts} />}
    />
  );
};
